<template>
  <div class="">
    <template v-if="!isWebview">
      <h4 class="box-title title">
        <span>{{ $t("dashboard.title.phone_app.ios") }}</span>
        <span> / {{ $t("dashboard.title.phone_app.android") }}</span>
      </h4>
    </template>
    <template v-else>
      <h4 class="box-title title">
        <span v-if="isWebviewIOS">{{$t("dashboard.title.phone.app.ios")}}</span>
        <span v-if="!isWebviewIOS">{{ $t("dashboard.title.phone_app.android") }}</span>
      </h4>
    </template>
			<!-- mobile mode or tablet mode-->
        <div class="box-ct" v-if="!isWebview && (mobileMode || tabletMode)">
				<div class="device-list">
					<div class="row row-narrow">
						<div class="col-md-4">
							<a href="#"  v-open-app-mobile
								:url-universal-link="linksAppList.FX_UNIVERSAL_LINK_URL" :url-app-store = "linksAppList.FX_APPSTORE_URL"
								:url-deep-link="linksAppList.FX_DEEP_LINK_URL" :url-webappstore-link="linksAppList.FX_APPSTORE_URL"
								class="device-list-item btn-red mobile_config_url">
								<i class="fab fa-apple"></i>
								<span class="device-title">{{$t('dashboard.title.fx' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.fx.note' )}}</span>
							</a>
  						</div>
						<div class="col-md-4">
							<a href="#"  v-open-app-mobile
								:url-android-link="linksAppList.FX_OPENAPP_ANDROID_URL" :url-webappstore-link="linksAppList.FX_GOOGLE_PLAY_URL"  class="device-list-item btn-red mobile_config_url">
								<i class="fab fa-android"></i>
								<span class="device-title">{{$t('dashboard.title.fx' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.fx.note' )}}</span>
							</a>
						</div>
 					</div>
				</div>
			</div>

			<!-- webview mode -->
			<div class="box-ct" v-if="isWebview">
				<div class="device-list">
					<div class="row row-narrow">
						<div class="col-md-4" v-if="isWebviewIOS">
							<a  href="#"  v-open-app-mobile
								:url-universal-link="linksAppList.FX_UNIVERSAL_LINK_URL" :url-app-store = "linksAppList.FX_APPSTORE_URL"
								:url-deep-link="linksAppList.FX_DEEP_LINK_URL" :url-webappstore-link="linksAppList.FX_APPSTORE_URL"
								class="device-list-item btn-red mobile_config_url">
								<i class="fab fa-apple"></i>
								<span class="device-title">{{$t('dashboard.title.fx' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.fx.note' )}}</span>
							</a>
						</div>
						<div class="col-md-4" v-if="!isWebviewIOS">
							<a href="#"  v-open-app-mobile
							   :url-android-link="linksAppList.FX_OPENAPP_ANDROID_URL" :url-webappstore-link="linksAppList.FX_GOOGLE_PLAY_URL"  class="device-list-item btn-red mobile_config_url">
								<i class="fab fa-android"></i>
								<span class="device-title">{{$t('dashboard.title.fx' )}}</span>
								<span class="device-desc">{{$t('dashboard.title.fx.note' )}}</span>
							</a>
						</div>
					</div>
				</div>
			</div>
			
			<!-- PC mode -->
			<div class="box-ct" v-if="!mobileMode && !tabletMode">
				<div class="device-list">
					<div class="row row-narrow">
						<div class="col-md-4">
  					<a :href="linksAppList.FX_APPSTORE_URL" class="device-list-item btn-red" target="blank">
 							<i class="fab fa-apple"></i>
 							<span class="device-title">{{$t('dashboard.title.fx' )}}</span>
 							<span class="device-desc">{{$t('dashboard.title.fx.note' )}}</span>
 						</a>
	  				</div>
	  				<div class="col-md-4">
	 						<a :href="linksAppList.FX_GOOGLE_PLAY_URL" class="device-list-item btn-red" target="blank">
	 							<i class="fab fa-android"></i>
	  							<span class="device-title">{{$t('dashboard.title.fx' )}}</span>
	  							<span class="device-desc">{{$t('dashboard.title.fx.note' )}}</span>
	  						</a>
	 					</div>
	 				</div>
				</div>
			</div>
		</div>
</template>

<script>
    /**
     * @author HungNS
     */

import {createNamespacedHelpers} from "vuex";

const { mapGetters: mapHeaderGetters } = createNamespacedHelpers("header");
export default {
  computed: {
    ...mapHeaderGetters(["linksAppList"]),
  },
};
</script>

<style>
.fab.fa-apple, .fab.fa-android, .fas.fa-mobile-alt {
  height: auto !important;
  text-align: center !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>